import React, {Component} from 'react';
import { Row, Col, Container, Button} from 'react-bootstrap';
import contactBlockImage from '../assets/contact-block.png';
import SectionHeading from '../components/section-heading';
import ThreeColumnGrid from '../components/three-columns-grid';
import ExpandView1 from '../components/expand-view-1';
import ExpandView2 from '../components/expand-view-2';
import QuoteBlock from '../components/quote-block';

class AboutUs extends Component {
  render() {
    return(
      <Container className="le-about-page">
        <div className="header">
          <h1>About Us</h1>
          <p>HOME . ABOUT</p>
        </div>
        <Row>
          <Col md={5} className="image-block">
            <img src={contactBlockImage} alt="contact-us" />
          </Col>
          <Col md={7} className="content-block">
            <SectionHeading heading="What we do" align="heading-left"/>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
            </p>
            <ExpandView1 />
            <ExpandView1 />
            <ExpandView1 />

            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>

            <Button className="le-btn le-btn-primary">Connect with us</Button>
          </Col>
        </Row>
        <QuoteBlock/>
        <SectionHeading subText="WHAT WE REFLECT" heading="Our Values" align="heading-center"/>
        <ThreeColumnGrid/>
        <SectionHeading subText="Looking to fill in" heading="Career" align="heading-center"/>
        <ExpandView2/>
        <ExpandView2/>
        <ExpandView2/>
        <ExpandView2/>
      </Container>
    )
  }
}

export default AboutUs;